export default "__VITE_ASSET__QyzKwTqr__"